<template xmlns="http://www.w3.org/1999/html">
    <div>
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> FAQ

                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="internal-page-main-section faq-section-main col-12">
            <div class="container">
                <div class="row">
                    <div class="survey-main-section col-12 float-l">
                        <div class="row">

                                <!-- Search form -->
                                <div class="btn btn-success form-group pull-right searchBtn sb-search-open faqSearch" >
                                    <input v-model="searchFAQ" class="form-control searchInput" type="text" placeholder="Search" aria-label="Search">
                                </div>
                                <div class="clearfix"></div>
                                <!--<template>
                                    <div role="tablist">
                                        <template v-for="(questionAnswer, index) in questionList">
                                            <b-card no-body class="mb-1">
                                                <b-card-header header-tag="header" class="p-1" role="tab">
                                                    <b-button block href="#" v-b-toggle="'accordion' + questionAnswer.id" variant="">{{questionAnswer.question}}</b-button>
                                                </b-card-header>
                                                <b-collapse :id="'accordion' + questionAnswer.id"  accordion="my-accordion" role="tabpanel">
                                                    <b-card-body>
                                                        <div class="col-12" v-html="questionAnswer.answer"></div>
                                                        <div class="clearfix"></div>
                                                    </b-card-body>
                                                </b-collapse>
                                            </b-card>
                                        </template>
                                    </div>
                                </template>
                                <div class="clearfix"></div>-->
                                <div class="accordion float-l width-full" id="accordionExample">
                                    <template v-for="(questionAnswer, index) in questionList">
                                        <div class="card">
                                            <div class="card-header" :id="'accordion' + questionAnswer.id">
                                                <h5 class="mb-0">
                                                    <button class="btn btn-link collapsed faqTitle" type="button" data-toggle="collapse" :data-target="'#'+'collapse' + questionAnswer.id" aria-expanded="false" :aria-controls="'collapse' + questionAnswer.id">
                                                        {{questionAnswer.question}}
                                                    </button>
                                                </h5>
                                            </div>
                                            <div :id="'collapse' + questionAnswer.id" class="collapse" :aria-labelledby="'accordion' + questionAnswer.id" data-parent="#accordionExample">
                                                <div class="card-body faqBody" v-html="questionAnswer.answer"></div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import TEST from "./backend/policiesandforms/test";
    var self;
    export default {
        name: 'FAQ',
        mixins: [SessioMixin],
        components: {

        },
        data() {
            return {
                question : '',
                answer : '',
                questionList: [],
                accordinndId : 0,
                firstload : true,
                searchFAQ : '',
        }
        },
        computed: {
        },
        watch: {
            searchFAQ: function (searchFAQ) {
                self.searchFaq();
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.MenuClose();
            self.getPermissions();
            self.getFAQ();
            self.getBuildVersion();
            this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
                // console.log('collapseId:', collapseId);
                // console.log('isJustShown:', isJustShown);
            })

        },

        methods: {
            searchFaq() {
                if (self.searchFAQ.length >= 0) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var data = {
                        search: self.searchFAQ,
                    };
                    HTTP.post("searchfaq", data, config)
                        .then(function (response) {
                            self.questionList = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
                }
            },
            getFAQ() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getfaq", '', config)
                    .then(function (response) {
                        self.questionList = response.data.content;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/FAQ.vue